import { useState, useContext } from "react";
import { Typography, Form, Space, Select, Input, Button } from "antd";
import {
  QuestionCircleTwoTone,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import { SpecSettingContext } from "../../../pages/SpecSetting";
import UpdateRuleStepDrawer from "./UpdateRuleStepDrawer";

const { Title, Text } = Typography;

const UpdateRuleStep = ({ approval }) => {
  const { blueprint, updateSettingBlueprint } = useContext(SpecSettingContext);

  const [drawerOpen, setDrawerOpen] = useState(false);

  const [updateRuleForm] = Form.useForm();

  return (
    <div>
      <UpdateRuleStepDrawer open={drawerOpen} setOpen={setDrawerOpen} />
      <Title level={4}>
        工單更新規則
        <Button
          type="text"
          shape="circle"
          icon={<QuestionCircleTwoTone />}
          onClick={() => setDrawerOpen(true)}
        />
      </Title>
      <Text type="secondary">
        設定 ERP 系統內已同步至 SFR 系統的工單中，若在 ERP 系統更動過，
        匹配特定規則的工單，需要將資訊再更新至 SFR
        系統，包括設備、員工、物料和途程工序等匹配策略。
      </Text>

      <Form
        form={updateRuleForm}
        disabled={approval}
        layout="vertical"
        requiredMark={false}
        initialValues={blueprint["updateRule"]}
        onValuesChange={(_, values) => {
          updateSettingBlueprint("updateRule", values);
        }}
        style={{ marginTop: 24 }}
      >
        <Form.Item shouldUpdate>
          {() => (
            <div>
              <Form.Item
                name="updateCondition"
                label="更新條件"
                rules={[{ required: true, message: "請選擇更新條件" }]}
              >
                <Select
                  options={[
                    { value: "specific", label: "特定欄位" },
                    { value: "any", label: "任一欄位" },
                  ]}
                />
              </Form.Item>
              {updateRuleForm.getFieldValue("updateCondition") ===
              "specific" ? (
                <Form.List name="columns">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Space key={key} style={{ paddingRight: "15px" }}>
                          <Form.Item
                            name={[name, "columnSource"]}
                            label="欄位來源"
                            rules={[
                              { required: true, message: "請選擇欄位來源" },
                            ]}
                          >
                            <Select
                              options={[
                                { value: "wooh", label: "小工單" },
                                { value: "wo", label: "大工單" },
                              ]}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[name, "columnName"]}
                            label="欄位"
                            rules={[{ required: true, message: "請選擇欄位" }]}
                          >
                            <Input />
                          </Form.Item>
                          <Form.Item name={[name, "note"]} label="備註">
                            <Input />
                          </Form.Item>
                          <MinusCircleOutlined
                            onClick={() => remove(name)}
                            style={{ color: "red" }}
                          />
                        </Space>
                      ))}
                      <Form.Item>
                        <Button
                          type="dashed"
                          onClick={() =>
                            add({ columnSource: "wooh", columnName: "" })
                          }
                          icon={<PlusOutlined />}
                        >
                          新增欄位
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              ) : null}
            </div>
          )}
        </Form.Item>
      </Form>
    </div>
  );
};

export default UpdateRuleStep;
